module.exports = "/images/ny-blck-6.jpg";